// profiler.js
import { Events } from "./events.js";

export const WorkflowProfiler = {
    _stats: {
        updates: 0,
        stepsChanged: 0,
        photosLoaded: 0,
        autoRefreshUpdates: 0,
        scrolls: 0,
        stepChanges: {}
    },

    markUpdate() {
        this._stats.updates++;
        Events.emit("prof:updated", this._stats);
    },

    markStepsChanged(stepCode) {
        this._stats.stepsChanged++;
        if (!this._stats.stepChanges[stepCode])
            this._stats.stepChanges[stepCode] = 0;
        this._stats.stepChanges[stepCode]++;
        Events.emit("prof:updated", this._stats);
    },

    markPhotosLoaded(count) {
        this._stats.photosLoaded += count;
        Events.emit("prof:updated", this._stats);
    },

    markAutoRefreshUpdate() {
        this._stats.autoRefreshUpdates++;
        Events.emit("prof:updated", this._stats);
    },

    markScroll() {
        this._stats.scrolls++;
        Events.emit("prof:updated", this._stats);
    },

    getStats() {
        return this._stats;
    }
};
